/* Actions */
export const AUTH_REQUEST = "AUTH_REQUEST";
export const ATTACH_JFPC_SCRIPT = "ATTACH_JFPC_SCRIPT";

/* Mutations */
export const SET_PUBLISHER_TOKEN = "SET_PUBLISHER_TOKEN";
export const SET_JFPC_SCRIPT_ATTACHED = "SET_JFPC_SCRIPT_ATTACHED";
